
class ReportsModuleLogic {
  identificationEventModule; 
  appContext;
  framework;

  constructor(_identificationEventModule,_appContext,_framework) {
    this.identificationEventModule = _identificationEventModule;
    this.appContext = _appContext;
    this.framework = _framework;
  }

  async searchForMerchantAccount(merchantAccountId,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchMerchantAccount(merchantAccountId,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        console.log(response);
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }    

  async fetchClientAccountArray(_successCallback,_errorCallback) {
    let appError = null;
    const condition = "where status_id='ACT'";
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchClientAccountArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  } 

  async fetchClientAccountBalanceInfoReport(clientAccountBalanceInfoReportRequest,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchClientAccountBalanceInfoReport(clientAccountBalanceInfoReportRequest,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        console.log(response);
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }   

  async fetchDepositSummaryReport(depositSummaryReportRequest,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchDepositSummaryReport(depositSummaryReportRequest,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        console.log(response);
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }   

  async fetchMerchantSummaryReport(merchantSummaryReportRequest,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchMerchantSummaryReport(merchantSummaryReportRequest,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        console.log(response);
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  } 

  async fetchProductSummaryReport(productSummaryReportRequest,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchProductSummaryReport(productSummaryReportRequest,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        console.log(response);
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }   

  async fetchGatewaySummaryReport(gatewaySummaryReportRequest,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchGatewaySummaryReport(gatewaySummaryReportRequest,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        console.log(response);
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }

  async fetchStaffUserArray(_successCallback,_errorCallback) {
    let appError = null;
    const condition = "where status_id='ACT'";
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchStaffUserArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }
  async fetchStaffRecentExaminationReport(staffRecentExaminationReportRequest,_successCallback,_errorCallback) {
    let appError = null;
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchStaffRecentExaminationReport(staffRecentExaminationReportRequest,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        console.log(response);
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  }  
 
  async fetchCheckinDeploymentArray(_successCallback,_errorCallback) {
    let appError = null;
    const condition = "where status_id='ACT'";
    const accessToken = this.framework.getAuthenticationSystem().getAccessToken();
    const response = await this.framework.getRestSystem().fetchCheckinDeploymentArray(condition,accessToken).catch(error => {
      appError = error;
      return null;
    }); 
    if(response !== null) {
      if(_successCallback !== null) {
        let json = response.data;
        _successCallback(json);
      }        
    }
    else {
      if(_errorCallback !== null) {
        _errorCallback(appError);
      }      
    }      
  } 

}


export default ReportsModuleLogic;